(function () {
  if (window.__totFilterDrawerFixInit) return;
  window.__totFilterDrawerFixInit = true;

  var TARGET_IDS = ['hdt-filter_form', 'hdt-shop-sidebar-drawer'];
  var MOBILE_MQ = window.matchMedia('(max-width: 1149px)');
  var CLEANUPS = new WeakMap();
  var HOST_BY_DIALOG = new WeakMap();
  var ACTIVE_IDS = new Set();
  var SAVED_SCROLL_Y = 0;
  var PENDING_SCROLL_Y = null;
  var SCAN_TICKING = false;

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function isTargetDialog(dialog) {
    return !!dialog && TARGET_IDS.indexOf(dialog.id) > -1;
  }

  function getScrollY() {
    return window.scrollY || window.pageYOffset || 0;
  }

  function isTargetControlId(controlId) {
    return !!controlId && TARGET_IDS.indexOf(controlId) > -1;
  }

  function captureOpenScroll(event) {
    if (!isMobile()) return;
    if (!event || !event.target || typeof event.target.closest !== 'function') return;
    var trigger = event.target.closest('[aria-controls], [data-controls]');
    if (!trigger) return;

    var controlId = trigger.getAttribute('aria-controls') || trigger.getAttribute('data-controls');
    if (!isTargetControlId(controlId)) return;
    PENDING_SCROLL_Y = getScrollY();
  }

  function lockBody() {
    document.documentElement.classList.add('tot-scroll-lock');
    document.body.classList.add('tot-scroll-lock');
    document.body.style.top = '-' + SAVED_SCROLL_Y + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  }

  function unlockBody() {
    document.documentElement.classList.remove('tot-scroll-lock');
    document.body.classList.remove('tot-scroll-lock');
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.position = '';
    document.body.style.width = '';
  }

  function resetDialogScroll(dialog) {
    if (!dialog) return;
    var inner = dialog.querySelector('.hdt-dialog-drawer__inner');
    if (inner) inner.scrollTop = 0;
    dialog.scrollTop = 0;
  }

  function applyLock(dialog) {
    if (!isTargetDialog(dialog) || !isMobile()) return;

    var id = dialog.id;
    if (ACTIVE_IDS.has(id)) {
      resetDialogScroll(dialog);
      return;
    }

    if (ACTIVE_IDS.size === 0) {
      var liveScrollY = getScrollY();
      SAVED_SCROLL_Y = PENDING_SCROLL_Y != null ? PENDING_SCROLL_Y : liveScrollY;
      PENDING_SCROLL_Y = null;
      lockBody();
    }

    ACTIVE_IDS.add(id);
    dialog.classList.add('tot-filter-drawer-open');

    var host = dialog.closest('hdt-drawer');
    if (host) {
      host.classList.add('tot-filter-lock-host');
      HOST_BY_DIALOG.set(dialog, host);
    }

    resetDialogScroll(dialog);
  }

  function releaseBodyAndRestore() {
    var restoreY = SAVED_SCROLL_Y;
    SAVED_SCROLL_Y = 0;
    unlockBody();

    requestAnimationFrame(function () {
      window.scrollTo(0, restoreY);
    });
  }

  function releaseLock(dialog) {
    if (!isTargetDialog(dialog)) return;

    var id = dialog.id;
    dialog.classList.remove('tot-filter-drawer-open');

    var host = HOST_BY_DIALOG.get(dialog);
    if (host) {
      host.classList.remove('tot-filter-lock-host');
      HOST_BY_DIALOG.delete(dialog);
    }

    if (!ACTIVE_IDS.has(id)) return;
    ACTIVE_IDS.delete(id);

    if (ACTIVE_IDS.size === 0) {
      releaseBodyAndRestore();
    }
  }

  function releaseById(id) {
    ACTIVE_IDS.delete(id);
    var dialog = document.getElementById(id);
    if (dialog) {
      dialog.classList.remove('tot-filter-drawer-open');
      var host = dialog.closest('hdt-drawer');
      if (host) host.classList.remove('tot-filter-lock-host');
    }
    if (ACTIVE_IDS.size === 0) {
      releaseBodyAndRestore();
    }
  }

  function syncFromOpenState(dialog) {
    if (!isTargetDialog(dialog)) return;
    if (dialog.hasAttribute('open')) {
      applyLock(dialog);
    } else if (ACTIVE_IDS.has(dialog.id)) {
      releaseLock(dialog);
    }
  }

  function bindDialog(dialog) {
    if (!isTargetDialog(dialog)) return;
    if (CLEANUPS.has(dialog)) return;

    var onDialogOpen = function () {
      applyLock(dialog);
    };
    var onDialogClose = function () {
      releaseLock(dialog);
    };

    dialog.addEventListener('dialog:open', onDialogOpen);
    dialog.addEventListener('dialog:close', onDialogClose);
    dialog.addEventListener('close', onDialogClose);
    dialog.addEventListener('cancel', onDialogClose);

    var openObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'attributes' && mutations[i].attributeName === 'open') {
          syncFromOpenState(dialog);
          break;
        }
      }
    });

    openObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });

    CLEANUPS.set(dialog, function () {
      dialog.removeEventListener('dialog:open', onDialogOpen);
      dialog.removeEventListener('dialog:close', onDialogClose);
      dialog.removeEventListener('close', onDialogClose);
      dialog.removeEventListener('cancel', onDialogClose);
      openObserver.disconnect();
    });

    syncFromOpenState(dialog);
  }

  function scanAndBind() {
    TARGET_IDS.forEach(function (id) {
      var dialog = document.getElementById(id);
      if (!dialog) {
        if (ACTIVE_IDS.has(id)) releaseById(id);
        return;
      }
      bindDialog(dialog);
      syncFromOpenState(dialog);
    });
  }

  function scheduleScan() {
    if (SCAN_TICKING) return;
    SCAN_TICKING = true;
    requestAnimationFrame(function () {
      SCAN_TICKING = false;
      scanAndBind();
    });
  }

  function forceUnlockAll() {
    TARGET_IDS.forEach(function (id) {
      var dialog = document.getElementById(id);
      if (dialog) {
        dialog.classList.remove('tot-filter-drawer-open');
        var host = dialog.closest('hdt-drawer');
        if (host) host.classList.remove('tot-filter-lock-host');
      }
    });

    if (ACTIVE_IDS.size > 0 || document.body.classList.contains('tot-scroll-lock')) {
      releaseBodyAndRestore();
    }

    ACTIVE_IDS.clear();
    PENDING_SCROLL_Y = null;
  }

  var pageObserver = new MutationObserver(function () {
    scheduleScan();
  });

  function init() {
    document.addEventListener('touchstart', captureOpenScroll, { capture: true, passive: true });
    document.addEventListener('click', captureOpenScroll, true);
    scanAndBind();
    pageObserver.observe(document.body, { childList: true, subtree: true });

    var onViewportChange = function (event) {
      if (event.matches) {
        scheduleScan();
        return;
      }
      forceUnlockAll();
    };

    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', onViewportChange);
    } else if (typeof MOBILE_MQ.addListener === 'function') {
      MOBILE_MQ.addListener(onViewportChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
